<template>
    <NuxtLayout>
        <div>
            <h1>Oops.. Error {{ error.statusCode }}</h1>

            <div>
                <NuxtLink to="/">Go to home page</NuxtLink>
            </div>

            <div class="mt-8">
                <NuxtLink to="/contact?theme=error-report">Report an error</NuxtLink>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup>
// import type { NuxtError } from '#app'

const props = defineProps({
    error: Object,
})
</script>
